"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSetExtension = void 0;
const index_js_1 = require("../../../../../schema/actions/parse/index.js");
const index_js_2 = require("../../symbols/index.js");
const parseSetExtension = (attribute, input, { transform = true } = {}) => {
    if ((0, index_js_2.isAddition)(input) && input[index_js_2.$ADD] !== undefined) {
        return {
            isExtension: true,
            *extensionParser() {
                const parser = new index_js_1.Parser(attribute).start(input[index_js_2.$ADD], { fill: false, transform });
                const parsedValue = { [index_js_2.$ADD]: parser.next().value };
                if (transform) {
                    yield parsedValue;
                }
                else {
                    return parsedValue;
                }
                const transformedValue = { [index_js_2.$ADD]: parser.next().value };
                return transformedValue;
            }
        };
    }
    if ((0, index_js_2.isDeletion)(input) && input[index_js_2.$DELETE] !== undefined) {
        return {
            isExtension: true,
            *extensionParser() {
                const parser = new index_js_1.Parser(attribute).start(input[index_js_2.$DELETE], { fill: false, transform });
                const parsedValue = { [index_js_2.$DELETE]: parser.next().value };
                if (transform) {
                    yield parsedValue;
                }
                else {
                    return parsedValue;
                }
                const transformedValue = { [index_js_2.$DELETE]: parser.next().value };
                return transformedValue;
            }
        };
    }
    return {
        isExtension: false,
        basicInput: input
    };
};
exports.parseSetExtension = parseSetExtension;
